import React from "react";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import { Box, TextField, ThemeProvider } from "@mui/material";
import { createTheme, StyledEngineProvider } from "@mui/material/styles";
import { getMinDate } from "../../constants/dateFunctions";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
  },
});

function EtaEndDate({ id, name, label, value, onChange }) {
  return (
    <Box p={1} width={"245px"}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <MobileDateTimePicker
              variant="dialog"
              id={id}
              name={name}
              label={label}
              value={value}
              onChange={onChange}
              ampm={false}
              inputFormat={"MM-DD-YYYY LT"}
              disableMaskedInput
              maxDate={moment().add(20, "days")}
              minDate={getMinDate()}
              maxDateMessage={"Date should not be more then 24 hours from now."}
              minDateMessage={`Date should not be previous to ${getMinDate()}.`}
              helperText="Enter date and time."
              renderInput={(params) => (
                <TextField {...params} variant="standard" sx={{ width: 1 }} />
              )}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Box>
  );
}

export default EtaEndDate;
